export default {
  services_number_title: "Anzahl der wählbaren Dienstleistungen",
  additional_information_after_booking_title:
    "Zusätzliche Informationen in der E-Mail nach der Buchung",
  additional_information_after_booking_subtitle:
    "Zusätzliche Informationen, die in E-Mails im Zusammenhang mit Servicebuchungen gesendet werden (Erstellung, Änderung und Erinnerungen an die Buchung). Wenn du die Benachrichtigungen bearbeitet hast, stelle sicher, dass die entsprechende Variable in deren Inhalt festgelegt ist: [ADDITIONAL_INFORMATION_AFTER_BOOKING].",
  additional_information_after_booking_dummy_text:
    "Dies ist ein Beispieltext, der durch zusätzliche Informationen nach der Buchung ersetzt wird, sofern diese in den Serviceeinstellungen angegeben wurden.",
  plugins_storage_100gb_cd_base_pro_name: "Dateispeicher 100 GB",
  plugins_storage_500gb_cd_base_pro_name: "Dateispeicher 500 GB",
  plugins_storage_100gb_cd_base_pro_description:
    "Mehr Speicherplatz für Dateien. Gewinne 100 GB zusätzlichen Platz, um Dateien mit Kunden auszutauschen und Anhänge über Buchungsformulare zu empfangen. Eine ideale Lösung, um die Kommunikation zu verbessern und den Kundenservice zu optimieren.",
  plugins_storage_500gb_cd_base_pro_description:
    "Maximaler Speicherplatz für deine Dateien. Nutze 500 GB Speicherplatz, um Dateien mit Kunden auszutauschen und Anhänge über Buchungsformulare ohne Einschränkungen zu empfangen. Unverzichtbar für schnell wachsende Unternehmen, die Professionalität und Komfort schätzen.",
  bookings_this_month: "Buchungen diesen Monat",
  bookings_all_processed: "Alle Buchungen",
  simple_store_product_transactions_this_month:
    "Verkaufte Produkte diesen Monat",
  files_storage_usage: "Genutzter Speicherplatz",
  files_storage_usage_from_available_prefix: "von verfügbaren",
  not_available_in_standard_plan: "Funktion nicht im Standardplan verfügbar",
  ai_tokens_usage: "Verbrauchte AI-Tokens",
  ai_tokens_usage_from_available_prefix: "von verfügbaren",
  ai_tokens_resets_at: "Wird zurückgesetzt",
  cancel_reason_dropdown_label: "Grund für die Kündigung des Abonnements",
  cancel_subscription_category_1_title: "Technische Probleme",
  cancel_subscription_category_1_reason_1_title:
    "Häufige Abstürze oder Ausfälle",
  cancel_subscription_category_1_reason_2_title: "Langsame Systemleistung",
  cancel_subscription_category_1_reason_3_title:
    "Schwer zu bedienende Benutzeroberfläche",
  cancel_subscription_category_1_reason_4_title:
    "Probleme mit Integrationen (z. B. Zahlungssystem, externe Kalender)",
  cancel_subscription_category_1_reason_5_title:
    "Sicherheitsbedenken (z. B. Datenschutzverletzungen)",
  cancel_subscription_category_1_reason_6_title:
    "Probleme mit der mobilen Mitarbeiter-App (z. B. Abstürze, Bugs)",
  cancel_subscription_category_2_title:
    "Persönliche oder geschäftliche Veränderungen",
  cancel_subscription_category_2_reason_1_title:
    "Änderung des Geschäftsmodells (z. B. geringerer Bedarf an Buchungen)",
  cancel_subscription_category_2_reason_2_title:
    "Budgetbeschränkungen oder finanzielle Schwierigkeiten",
  cancel_subscription_category_2_reason_3_title:
    "Zu viel Arbeitsaufwand, um das System zu verwalten",
  cancel_subscription_category_2_reason_4_title:
    "Schließung oder Verkleinerung des Unternehmens",
  cancel_subscription_category_2_reason_5_title:
    "Keine Zeit, um Buchungen zu verwalten",
  cancel_subscription_category_3_title: "Preis- und Wettbewerbsfaktoren",
  cancel_subscription_category_3_reason_1_title:
    "Günstigere Alternativen verfügbar",
  cancel_subscription_category_3_reason_2_title:
    "Preiserhöhung oder Änderung des Abrechnungsmodells",
  cancel_subscription_category_4_title: "Probleme mit der Benutzererfahrung",
  cancel_subscription_category_4_reason_1_title:
    "Schwierigkeiten bei der Navigation im System",
  cancel_subscription_category_4_reason_2_title: "Fehlende wichtige Funktionen",
  cancel_subscription_category_4_reason_3_title:
    "Zu kompliziert für mein Team oder Unternehmen",
  cancel_subscription_category_4_reason_4_title:
    "Langsamer oder wenig hilfreicher Kundenservice",
  cancel_subscription_category_4_reason_5_title:
    "Begrenzte Anpassungsmöglichkeiten",
  cancel_subscription_category_4_reason_6_title:
    "Komplizierter Einrichtungs- oder Implementierungsprozess",
  cancel_subscription_category_5_title: "Externe und marktbedingte Faktoren",
  cancel_subscription_category_5_reason_1_title:
    "Änderungen in Markttrends (z. B. Wechsel zu Buchungen über soziale Medien)",
  cancel_subscription_category_5_reason_2_title:
    "Wirtschaftskrise oder Abschwung",
  cancel_subscription_category_5_reason_3_title:
    "Änderungen in den gesetzlichen Vorschriften",
  cancel_subscription_category_6_title: "Sonstiges",
  cancel_subscription_category_6_reason_1_title: "Grund nicht aufgeführt",
  cancel_subscription_category_6_reason_2_title:
    "Ich möchte keinen Grund angeben",
  cancel_plan_and_delete_data: "Kündigen und meine Daten löschen",
  cancel_plan_do_nothing: "Nichts tun",
  cancel_plan_and_keep_data_confirmation_label:
    "Bist du sicher, dass du dein Abonnement kündigen, aber deine Daten behalten möchtest?",
  cancel_plan_and_keep_data_confirmation_info:
    "Das Abonnement wird am Ende des bereits bezahlten Abrechnungszeitraums gekündigt. Die Daten werden sicher auf unseren Servern gespeichert und können jederzeit nach der Reaktivierung des Abonnements wiederhergestellt werden.",
  scheduled_cancel_keeps_data_info:
    "Dein Plan wird gekündigt, aber deine Daten bleiben gespeichert",
  no_just_checking_title: "Nein, ich schaue nur",
  payment_deadline_before_start_variable:
    "Zahlungsfrist vor Beginn jeder wiederkehrenden Buchung",
  send_payment_reminder_before_start_variable:
    "Zeit der Zahlungserinnerungsbenachrichtigung vor der Buchung",
  booking_awaiting_payment_full_description:
    "Vollständige Informationen zur erforderlichen Zahlung",
  booking_awaiting_payment_full_description_example:
    "Die Buchung wird storniert, wenn keine Zahlung innerhalb von 30 min erfolgt. Klicke unten, um zu deiner Buchung zu gelangen und die Zahlung vorzunehmen.",
  recurring_meeting_in_the_past_warning:
    'Ein wiederkehrendes Meeting mit Startdaten in der Vergangenheit kann nicht erstellt werden. Wähle ein Startdatum in der Zukunft oder deaktiviere die Option "Regelmäßig wiederholen".',
  // Booking overlaps dialog
  booking_overlaps_dialog_title: "Kalenderkonflikt erkannt",
  booking_overlaps_dialog_message:
    "Bei der Überprüfung der Verfügbarkeit haben wir festgestellt, dass der ausgewählte Termin mit bestehenden Buchungen oder Sperrzeiten kollidiert. Konfliktdetails:",
  booking_overlaps_count: "Anzahl der kollidierenden Buchungen",
  unavailable_slot_overlaps_count: "Anzahl der kollidierenden Sperrzeiten",
  booking_overlaps_dialog_question: "Möchtest du trotzdem fortfahren?",
  selected_date: "Ausgewähltes Datum",
  single_booking: "Einzelbuchung",
  external_api_service_not_enabled_error:
    "Leider ist die API-Funktion für dieses Konto nicht verfügbar.",
  service_not_available_at_selected_time:
    "Der Service ist zum ausgewählten Zeitpunkt nicht verfügbar.",
  offline_mode: "Du bist offline",
  offline_description:
    "Die Anwendung benötigt eine Internetverbindung zum Funktionieren.",
  retry: "Erneut versuchen",
  checking_connection: "Verbindung wird überprüft...",
  waiting_for_connection: "Warten auf Verbindung",
  "2fa_verify_title": "Zwei-Faktor-Authentifizierung",
  "2fa_verify_description":
    "Gib deinen 6-stelligen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode:",
  "2fa_recovery_code_label": "Wiederherstellungscode",
  "2fa_use_recovery_code": "Wiederherstellungscode verwenden",
  "2fa_use_app_code": "App-Code verwenden",
  "2fa_verify_incorrect_error":
    "Der 2FA-Code ist falsch. Bitte versuche es erneut.",
  "2fa_session_expired_error":
    "Deine 2FA-Sitzung ist abgelaufen. Bitte melde dich erneut an.",
  "2fa_verification_cancelled":
    "Die Zwei-Faktor-Authentifizierung wurde abgebrochen. Bitte versuche es erneut.",
  enable_2fa: "2FA aktivieren",
  enable_2fa_title: "2-Stufen-Verifizierung aktivieren",
  disable_2fa: "2FA deaktivieren",
  disable_2fa_title: "2-Stufen-Verifizierung deaktivieren",
  "2fa_manual_setup": "Kann nicht scannen? Gib diesen Code manuell ein:",
  "2fa_recovery_codes_title": "Wiederherstellungscodes",
  "2fa_download_codes": "Codes herunterladen",
  "2fa_disable_description":
    "Du bist dabei, die 2-Stufen-Verifizierung zu deaktivieren. Das macht dein Konto weniger sicher.",
  "2fa_disable_warning":
    "Das Deaktivieren der 2-Stufen-Verifizierung verringert die Sicherheit deines Kontos.",
  "2fa_verify_to_disable": "Identität überprüfen",
  "2fa_verify_to_disable_description":
    "Gib einen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode, um die 2-Stufen-Verifizierung zu deaktivieren.",
  warning: "Warnung",
  current_password: "Aktuelles Passwort",
  incorrect_password: "Falsches Passwort. Bitte versuche es erneut.",
  "2fa_setup_failed": "2FA-Einrichtung fehlgeschlagen",
  "2fa_activation_failed": "2FA-Aktivierung fehlgeschlagen",
  "2fa_verification_code": "Verifizierungscode",
  "2fa_disabled_success": "2FA wurde erfolgreich deaktiviert",
  "2fa_disable_failed": "2FA-Deaktivierung fehlgeschlagen",
  "2fa_step_1_password_title": "Passwort eingeben",
  "2fa_step_1_scan_title": "QR-Code scannen",
  "2fa_step_2_verify_title": "Einrichtung überprüfen",
  "2fa_authenticator_apps_required": "Authenticator-App erforderlich",
  "2fa_setup_secure_subtitle":
    "Wähle und installiere eine sichere 2FA-App zum Schutz deines Kontos",
  "2fa_apps_installation_note":
    "Installiere eine dieser Apps auf deinem Handy, bevor du mit der Einrichtung fortfährst.",
  "2fa_scan_with_app": "Scanne diesen QR-Code mit deiner Authenticator-App",
  "2fa_enter_code_from_app":
    "Gib den 6-stelligen Code aus deiner Authenticator-App ein",
  "2fa_recovery_codes_warning":
    "Bewahre diese Codes an einem sicheren Ort auf. Jeder Code kann nur einmal verwendet werden.",
  "2fa_enter_password_to_continue":
    "Gib dein aktuelles Passwort ein, um deinen einzigartigen QR-Code zu generieren",
  "2fa_enter_password_to_disable":
    "Gib dein aktuelles Passwort ein, um die Deaktivierung der 2FA zu bestätigen",
  "2fa_disable_verification_description":
    "Gib dein aktuelles Passwort und einen Code aus deiner Authenticator-App ein oder verwende einen Wiederherstellungscode, um die 2-Stufen-Verifizierung zu deaktivieren.",
  "2fa_recovery_codes_description":
    "Diese Backup-Codes ermöglichen dir den Zugang zu deinem Konto, falls du deine Authenticator-App verlierst. Jeder Code kann nur einmal verwendet werden, bewahre sie an einem sicheren Ort auf.",
  security_settings: "Sicherheitseinstellungen",
  security_settings_description:
    "Verwalte deine Kontosicherheitseinstellungen und Authentifizierungsmethoden.",
  "2fa_security_title": "2-Stufen-Verifizierung",
  "2fa_security_description":
    "Füge deinem Konto eine zusätzliche Sicherheitsebene mit der 2-Stufen-Verifizierung hinzu.",
  reset_password_description:
    "Sende einen Link zum Zurücksetzen des Passworts an deine E-Mail-Adresse.",
  "2fa_enabled_success": "2FA wurde erfolgreich aktiviert",
  linkedin: "LinkedIn",
  profile_company_social_media_linkedin_label_input:
    "Link zu einem LinkedIn-Profil",
  logs_diff_linkedin: "Link zu einem LinkedIn-Profil",
  tiktok: "TikTok",
  profile_company_social_media_tiktok_label_input:
    "Link zu einem TikTok-Profil",
  logs_diff_tiktok: "Link zu einem TikTok-Profil",
  wb_linkedin: "LinkedIn-URL",
  wb_tiktok: "TikTok-URL",
  // Chatwoot package
  plugins_calendesk_chat_cd_base_standard_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_standard_description:
    "Verbessere deine Kundenkommunikation mit Calendesk Chat. Biete Echtzeit-Support, beantworte Fragen und interagiere direkt von deiner Buchungsseite aus mit deinen Kunden. Perfekt für Unternehmen, die stärkere Kundenbeziehungen aufbauen möchten.",
  plugins_calendesk_chat_cd_base_pro_name: "Calendesk Chat",
  plugins_calendesk_chat_cd_base_pro_description:
    "Verbessere deine Kundenkommunikation mit Calendesk Chat. Biete Echtzeit-Support, beantworte Fragen und interagiere direkt von deiner Buchungsseite aus mit deinen Kunden. Perfekt für Unternehmen, die stärkere Kundenbeziehungen aufbauen möchten.",
  number_of_agents: "Anzahl der Agenten",
  agents_plural: "Agenten",
  // Chatwoot integration
  integrations_category_customer_support: "Kundensupport",
  chatwoot_title: "Calendesk Chat",
  chatwoot_description:
    "Verwalte deinen Live-Chat-Support. Greife auf das Dashboard zu, konfiguriere Agenten und sieh Gespräche ein.",
  chatwoot_package_not_active:
    "Das Calendesk Chat-Paket ist nicht aktiv. Bitte aktiviere es in deinen Abonnementeinstellungen.",
  chatwoot_setup_title: "Chat-Support einrichten",
  chatwoot_setup_info:
    'Calendesk Chat ist eine separate Anwendung unter <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>, wo du Kundengespräche verwaltest.',
  chatwoot_setup_sso_warning:
    "Alle Calendesk-Administratoren mit Zugriff auf Integrationen können sich im Chat-Dashboard anmelden.",
  chatwoot_setup_next_steps_title: "Nach der Einrichtung:",
  chatwoot_setup_next_step_1:
    'Ein Chat-Konto wird auf <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a> erstellt',
  chatwoot_setup_next_step_2:
    "Administratoren werden sich mit einem Klick über das Calendesk-Menü im Chat-Dashboard anmelden können",
  chatwoot_setup_next_step_3:
    "Du kannst das Chat-Widget zu deiner Buchungsseite hinzufügen - den Einbettungscode findest du im Chat-Dashboard",
  chatwoot_company_section_title: "Firmendaten",
  chatwoot_admin_section_title: "Chat-Administrator",
  chatwoot_business_name: "Firmenname",
  chatwoot_business_name_hint:
    "Für Kunden im Chat-Widget und in Benachrichtigungen sichtbar",
  chatwoot_admin_name: "Name",
  chatwoot_admin_email: "E-Mail",
  chatwoot_support_email: "Kundensupport-E-Mail",
  chatwoot_support_email_placeholder: "z.B. support@ihrfirma.de",
  chatwoot_support_email_hint:
    "Kunden sehen diese Adresse als Absender von E-Mail-Antworten Ihres Teams",
  chatwoot_start_integration: "Einrichten",
  chatwoot_integration_active: "Calendesk Chat ist aktiv und einsatzbereit.",
  chatwoot_dashboard_info:
    'Verwalte deine Gespräche, Agenten und Einstellungen im Chat-Dashboard unter <a href="https://chat.calendesk.com" target="_blank">chat.calendesk.com</a>.',
  chatwoot_sso_warning:
    "Alle Calendesk-Administratoren mit Zugriff auf Integrationen können sich mit einem Klick im Chat-Dashboard anmelden.",
  chatwoot_open_dashboard: "Dashboard öffnen",
  chatwoot_agent_limit: "Agentenplätze",
  chatwoot_buy_more_agents: "Mehr Agenten benötigt? Paket upgraden",
  chatwoot_integration_success:
    "Calendesk Chat wurde erfolgreich eingerichtet!",
  chatwoot_integration_error:
    "Calendesk Chat konnte nicht eingerichtet werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_sso_error:
    "Das Chat-Dashboard konnte nicht geöffnet werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_suspend_button: "Pausieren",
  chatwoot_suspend_title: "Calendesk Chat pausieren",
  chatwoot_suspend_warning:
    "Die Pausierung deaktiviert das Chat-Widget auf der Website für Endkunden, <strong>hat jedoch keinen Einfluss auf die Paketaktivität oder die damit verbundenen Gebühren</strong>.<br><br>Um das Paket zu kündigen, gehe zu <strong>Abrechnungen → Abo</strong> und wähle <strong>Deaktivieren</strong>.",
  chatwoot_suspend_confirm: "Pausieren",
  chatwoot_suspend_success: "Calendesk Chat wurde pausiert.",
  chatwoot_suspend_error:
    "Calendesk Chat konnte nicht pausiert werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_suspended_info: "Ihr Calendesk Chat-Konto ist derzeit pausiert.",
  chatwoot_suspended_data_preserved:
    "Alle Ihre Gespräche und Einstellungen werden gespeichert und bei der Reaktivierung wiederhergestellt.",
  chatwoot_reactivate_button: "Reaktivieren",
  chatwoot_reactivation_success: "Calendesk Chat wurde reaktiviert!",
  chatwoot_reactivation_error:
    "Calendesk Chat konnte nicht reaktiviert werden. Bitte versuche es erneut oder kontaktiere den Support.",
  chatwoot_suspended_tooltip: "Pausiert - klicken zum Reaktivieren",
  chatwoot_agent_limit_exceeded:
    "Du hast @{current} Agenten, aber dein Paket erlaubt nur @{limit}.",
  chatwoot_agent_limit_contact_support:
    "Um Calendesk Chat zu reaktivieren, kontaktiere bitte unser Support-Team. Wir helfen dir, die Anzahl der Agenten an dein Paketlimit anzupassen.",
  contact_support: "Support kontaktieren",
  chatwoot_min_agents_info:
    "Mindestens @{count} Agenten erforderlich basierend auf Ihrer aktuellen Calendesk Chat-Konfiguration.",
  chatwoot_close_confirm_title: "Formular schließen?",
  chatwoot_close_confirm_warning:
    "Ihre eingegebenen Daten wurden nicht gespeichert und gehen verloren.",
  chatwoot_close_confirm_yes: "Schließen",
  chatwoot_close_confirm_no: "Zurück zum Formular",

  dialog_close_confirm_title: "Schließen?",
  dialog_close_confirm_warning: "Nicht gespeicherte Änderungen gehen verloren.",
  dialog_close_confirm_yes: "Schließen",
  dialog_close_confirm_no: "Abbrechen",

  // Reports
  reports: "Berichte",
  reports_granularity: "Gruppieren nach",
  reports_revenue: "Umsatz & Zahlungen",
  reports_bookings: "Buchungen",
  reports_team: "Mein Team",
  reports_customers: "Kunden & Handel",
  reports_clients: "Kunden",
  reports_subscriptions: "Abonnements",
  reports_products: "Produkte",
  reports_tab_revenue: "Umsatz",
  date_range: "Zeitraum",
  vs_previous_period: "vs vorheriger Zeitraum",
  reports_revenue_timeline: "Umsatz im Zeitverlauf",
  reports_top_services: "Top-Dienstleistungen",
  reports_top_products: "Top-Produkte",
  reports_payment_providers: "Zahlungsmethoden",
  reports_payment_methods_count: "Transaktionen nach Zahlungsmethode",
  reports_payment_methods_value: "Umsatz nach Zahlungsmethode",
  reports_payment_timeline: "Zahlungen im Zeitverlauf",
  reports_bookings_timeline: "Buchungen im Zeitverlauf",
  reports_by_service: "Nach Dienstleistung",
  reports_by_employee: "Nach Mitarbeiter",
  reports_by_delivery_type: "Nach Lieferart",
  reports_cancellation_reasons: "Stornierungsgründe",
  reports_by_day: "Nach Wochentag",
  reports_by_hour: "Nach Stunde",
  reports_heatmap: "Buchungs-Heatmap",
  reports_employee_performance: "Team-Leistung",
  reports_service_ranking: "Dienstleistungsranking",
  reports_by_category: "Nach Kategorie",
  reports_locations: "Standorte",
  reports_customer_segments: "Kundenbindung",
  reports_top_customers: "Top-Kunden",
  reports_product_revenue_timeline: "Produktumsatz im Zeitverlauf",
  reports_top_subscriptions: "Top-Abonnements",
  reports_subscription_timeline: "Neue Abonnements im Zeitverlauf",
  reports_revenue_forecast: "Umsatzprognose",
  reports_bookings_forecast: "Buchungsprognose",

  // Section headers
  reports_section_key_metrics: "Kennzahlen",
  reports_section_key_metrics_tooltip:
    "<b>Kennzahlen</b><br><br>Deine wichtigsten Geschäftskennzahlen im gewählten Zeitraum. Pfeile zeigen Veränderungen im Vergleich zum vorherigen Zeitraum gleicher Länge.",
  reports_section_trends: "Trends",
  reports_section_trends_tooltip:
    "<b>Trends</b><br><br>Wie sich dein Umsatz und deine Buchungen im gewählten Zeitraum verändert haben.",
  reports_section_revenue: "Umsatz",
  reports_section_revenue_tooltip:
    "<b>Umsatz</b><br><br>Gesamteinnahmen aus allen Quellen im gewählten Zeitraum. Nur <b>abgeschlossene Zahlungen</b> werden gezählt.<br><br>Enthält:<br>• <b>Umsatzaufschlüsselung</b> — aus Buchungen, Abonnements und Produkten<br>• <b>Durchschn. Buchungswert</b> und <b>Buchungszahlungsrate</b><br>• <b>Umsatzverlauf</b> — wie sich die Einnahmen im Zeitverlauf verändert haben<br>• <b>Top-Dienstleistungen, Abonnements und Produkte</b> — nach Umsatz sortiert<br>• <b>Zahlungsmethoden</b> — Transaktionsanzahl und Umsatz pro Methode",
  reports_section_bookings: "Buchungen",
  reports_section_bookings_tooltip:
    "<b>Buchungen</b><br><br>Buchungsstatus, Volumen im Zeitverlauf und Aufschlüsselung nach Dienstleistung und Teammitglied im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Statusaufschlüsselung</b> — genehmigt, erledigt, storniert<br>• <b>Buchungsverlauf</b> — Volumenveränderungen im Zeitverlauf<br>• <b>Nach Dienstleistung und Teammitglied</b> — am häufigsten gebuchte Dienste und am meisten beschäftigte Mitarbeiter",
  reports_section_patterns: "Buchungsmuster",
  reports_section_patterns_tooltip:
    "<b>Buchungsmuster</b><br><br>Wann deine Kunden am liebsten buchen. Nutze das zur Optimierung deines Zeitplans.<br><br>Enthält:<br>• <b>Heatmap der Stoßzeiten</b> — beliebteste Tage und Uhrzeiten<br>• <b>Beliebtester Tag</b> — welcher Wochentag die meisten Buchungen hat<br>• <b>Nach Uhrzeit</b> — Verteilung der Buchungen über den Tag",
  reports_section_employees: "Mein Team",
  reports_section_employees_tooltip:
    "<b>Mein Team</b><br><br>Wie jedes Teammitglied im gewählten Zeitraum abgeschnitten hat.<br><br>Enthält:<br>• <b>Erledigte Buchungen</b> — Anzahl abgeschlossener Buchungen pro Person<br>• <b>Generierter Umsatz</b> — Einnahmen aus ihren Buchungen<br>• <b>Kalenderauslastung</b> — wie viel der verfügbaren Arbeitszeit gebucht war",
  reports_section_services: "Dienstleistungen",
  reports_section_services_tooltip:
    "<b>Dienstleistungen</b><br><br>Beliebteste Dienstleistungen und ihre Einnahmen im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Buchungen pro Dienstleistung</b> — Anzahl genehmigter und erledigter Buchungen<br>• <b>Umsatz pro Dienstleistung</b> — generierte Einnahmen",
  reports_section_locations: "Standorte",
  reports_section_locations_tooltip:
    "<b>Standorte</b><br><br>Leistungsaufschlüsselung nach Standort und Durchführungsart im gewählten Zeitraum.",
  reports_section_customers: "Kunden",
  reports_section_customers_tooltip:
    "<b>Kunden</b><br><br>Wer am häufigsten bucht, wer am meisten ausgibt und wie engagiert deine Kunden im gewählten Zeitraum sind.<br><br>Enthält:<br>• <b>Neue Kunden</b> — registriert im gewählten Zeitraum<br>• <b>Aktive Kunden</b> — hatten mindestens eine Buchung<br>• <b>Bindungsdiagramm</b> — Erstbesucher, Wiederkehrende und treue Stammkunden<br>• <b>Top-Kunden</b> — mit den höchsten Ausgaben im gewählten Zeitraum",
  reports_section_customer_overview: "Kunden",
  reports_section_customer_overview_tooltip:
    "<b>Kunden</b><br><br>Diese Werte umfassen deine gesamte Geschichte und ändern sich nicht mit dem Datumsfilter.",
  reports_section_customer_activity: "Aktivität im Zeitraum",
  reports_section_customer_activity_tooltip:
    "<b>Aktivität im Zeitraum</b><br><br>Wie sich deine Kunden im gewählten Zeitraum verhalten haben — Buchungen, Bindung und Präferenzen.",
  reports_section_products: "Produkte",
  reports_section_products_tooltip:
    "<b>Produkte</b><br><br>Produktverkäufe, Umsatz im Zeitverlauf und Bestseller im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Gesamter Produktumsatz</b> im gewählten Zeitraum<br>• <b>Umsatzverlauf</b> — wie sich die Produktverkäufe über die Zeit verändert haben<br>• <b>Top-Produkte</b> — Bestseller nach Umsatz",
  reports_section_subscriptions: "Abonnements",
  reports_section_subscriptions_tooltip:
    "<b>Abonnements</b><br><br>Umsatz, Verlängerungen und Nutzung deiner Abo-Pläne im gewählten Zeitraum.<br><br>Enthält:<br>• <b>Aktive Abonnements</b> — wie viele Kunden gerade einen aktiven Plan haben<br>• <b>Umsatz</b> — wie viel du im gewählten Zeitraum mit Abonnements verdient hast<br>• <b>Verlängerungsrate</b> — wie viele Abonnenten mehr als einmal bezahlt haben (höher = Kunden kommen wieder)<br>• <b>Top-Abonnements</b> — welche Pläne am meisten Geld einbringen<br>• <b>Nutzung</b> — nutzen die Abonnenten ihre enthaltenen Buchungen tatsächlich?",
  reports_section_booking_status: "Buchungsstatus",
  reports_section_cancellation_reasons: "Stornierungsgründe",
  reports_section_peak_hours: "Stoßzeiten",
  reports_section_peak_hours_tooltip:
    "<b>So liest du dieses Diagramm:</b><br><br><b>Zeilen</b> = Wochentage<br><b>Spalten</b> = Uhrzeiten (00:00–23:00)<br><br>Jede Zelle zeigt die <b>Gesamtzahl</b> genehmigter und erledigter Buchungen, die an diesem Tag und zu dieser Stunde über den <b>gesamten gewählten Zeitraum</b> geplant waren.<br><br><b>Beispiel:</b> Wenn du 3 Monate gewählt hast, zeigt die Zelle Montag 10:00 wie viele Buchungen an allen Montagen um 10:00 in diesen 3 Monaten zusammen stattfanden.<br><br>🟦 Dunklere Farbe = mehr Buchungen",
  reports_section_busiest_day: "Geschäftigster Wochentag",
  stats_monday: "Montag",
  stats_tuesday: "Dienstag",
  stats_wednesday: "Mittwoch",
  stats_thursday: "Donnerstag",
  stats_friday: "Freitag",
  stats_saturday: "Samstag",
  stats_sunday: "Sonntag",
  stats_mon: "Mo",
  stats_tue: "Di",
  stats_wed: "Mi",
  stats_thu: "Do",
  stats_fri: "Fr",
  stats_sat: "Sa",
  stats_sun: "So",
  reports_section_delivery_type: "Nach Liefertyp",
  reports_section_peak_times: "Beliebteste Zeiten",
  reports_bookings_by_hour: "Buchungen nach Uhrzeit",
  reports_bookings_by_service: "Top Dienstleistungen",
  reports_bookings_by_employee: "Top Teammitglieder",
  reports_booking_lead_time: "Buchungsvorlaufzeit",
  reports_bookings_by_location: "Buchungen nach Standort",

  // Renderer-specific notes
  reports_employee_performance_note:
    'Kalenderauslastung zeigt "--", wenn für dieses Teammitglied keine Arbeitszeiten festgelegt wurden.',
  reports_customer_segments_note:
    "Teilt deine aktiven Kunden in drei Gruppen basierend auf der Buchungshistorie auf. Alle drei ergeben zusammen die aktiven Kunden.",
  reports_top_customers_note:
    "Der angezeigte Gesamtumsatz gilt für die gesamte Kundengeschichte, nicht nur für diesen Zeitraum.",
  reports_bookings_timeline_note:
    "Genehmigte und erledigte Buchungen, basierend auf dem Buchungsdatum.<br><br><b>Prognose</b>: eine gestrichelte Linie für kommende Zeiträume — Buchungen, die bereits geplant sind (genehmigt oder mit ausstehender Zahlung).",
  reports_services_by_category: "Buchungen nach Kategorie",
  reports_services_by_category_note:
    "Anzahl genehmigter und erledigter Buchungen pro Dienstleistungskategorie im gewählten Zeitraum.",
  reports_service_ranking_note:
    "Sortiert nach Anzahl der Buchungen. Klicke auf eine Spalte, um neu zu sortieren.",
  reports_top_products_note:
    "Produkte nach Umsatz im gewählten Zeitraum sortiert.",
  reports_top_subscriptions_note:
    "Abonnement-Pläne nach Umsatz im gewählten Zeitraum sortiert.",
  reports_product_revenue_timeline_note:
    "Wie sich der Produktumsatz im gewählten Zeitraum verändert hat.",
  reports_subscription_timeline_note: "Anzahl neuer Abonnements pro Zeitraum.",
  reports_mrr_trend: "Neue Abonnements",
  reports_subscription_usage: "Abonnement-Nutzung",
  reports_subscription_usage_tooltip:
    "Nutzen deine Abonnenten die Buchungen, die in ihren Plänen enthalten sind?<br><br>• <b>Buchungslimit-Nutzung</b> — wenn ein Plan 10 Buchungen enthält und ein Kunde 3 genutzt hat, sind das 30%. Das ist der Durchschnitt aller Abonnenten.<br>• <b>Ungenutzte Buchungen</b> — die Gesamtzahl der enthaltenen Buchungen, die niemand genutzt hat. Eine hohe Zahl bedeutet, dass Abonnenten verfügbare Buchungen verschwenden.",

  // Stats labels — KPI cards, table columns, chart headers
  // Dashboard
  stats_revenue: "Umsatz",
  stats_bookings: "Buchungen",
  stats_subscriptions: "Abonnements",
  stats_products: "Produkte",
  stats_new_customers: "Neue Kunden",
  stats_cancellation_rate: "Stornoquote",
  // Revenue
  stats_avg_booking_value: "Durchschn. Buchungswert",
  stats_total_revenue: "Gesamtumsatz",
  stats_from_bookings: "Buchungen",
  stats_from_products: "Produkte",
  stats_from_subscriptions: "Abonnements",
  // Team
  stats_active_employees: "Aktive Mitarbeiter",
  stats_team_revenue: "Teamumsatz",
  stats_schedule_fill_rate: "Kalenderauslastung",
  stats_total_booked_hours: "Gebuchte Stunden gesamt",
  // Bookings
  stats_total_bookings: "Alle Buchungen",
  stats_approved: "Genehmigt",
  stats_done: "Erledigt",
  stats_cancelled: "Storniert",
  stats_payment: "Ausstehende Zahlung",
  stats_status: "Status",
  // Tables — common
  stats_service: "Dienstleistung",
  stats_employee: "Mitarbeiter",
  stats_delivery_type: "Lieferart",
  stats_share: "Anteil",
  stats_reason: "Grund",
  stats_cancellations: "Stornierungen",
  stats_category: "Kategorie",
  stats_location: "Standort",
  stats_type: "Typ",
  stats_provider: "Methode",
  stats_transactions: "Transaktionen",
  stats_value: "Gesamt",
  stats_product: "Produkt",
  stats_quantity: "Menge",
  stats_subscription: "Abonnement",
  stats_customer: "Kunde",
  stats_email: "E-Mail",
  // Employees
  stats_customers_served: "Bediente Kunden",
  stats_utilization: "Auslastung",
  stats_available_hours: "Verfügbare Stunden",
  stats_booked_hours: "Gebuchte Stunden",
  // Services
  stats_unique_customers: "Einzigartige Kunden",
  // Customers
  stats_total_customers: "Alle Kunden",
  stats_active_customers: "Aktive Kunden",
  stats_returning_customers: "Wiederkehrende Kunden",
  stats_retention_rate: "Bindungsrate",
  stats_customer_ltv: "Kundenwert",
  stats_avg_days_between_visits: "Durchschn. Tage zw. Buchungen",
  stats_preferred_delivery: "Bevorzugte Lieferart",
  stats_preferred_payment: "Bevorzugte Zahlung",
  stats_total_spent: "Gesamtausgaben",
  // Products
  stats_total_sold: "Gesamt verkauft",
  stats_product_revenue: "Produktumsatz",
  // Subscriptions
  stats_active_subscriptions: "Aktive Abonnements",
  stats_subscription_revenue: "Abonnementumsatz",
  stats_renewal_rate: "Verlängerungsrate",
  stats_active_users: "Aktive Nutzer",
  stats_avg_utilization: "Buchungslimit-Nutzung",
  stats_booking_limit_usage: "Buchungslimit-Nutzung",
  stats_unused_booking_slots: "Ungenutzte Buchungen",
  stats_unused_bookings: "Ungenutzte Buchungen",
  // Payments
  stats_total_transactions: "Alle Transaktionen",
  stats_total_value: "Gesamtwert",
  stats_booking_payment_rate: "Buchungszahlungsrate",
  stats_method: "Methode",
  // Patterns
  stats_day: "Tag",
  stats_hour: "Stunde",
  stats_busiest_day: "Aktivster Tag",
  stats_busiest_hour: "Aktivste Stunde",
  stats_average_lead_time: "Durchschn. Tage im Voraus",
  stats_median_lead_time: "Median Tage im Voraus",
  // Forecast
  stats_month: "Monat",
  stats_projected: "Prognose",
  stats_low_estimate: "Untere Schätzung",
  stats_high_estimate: "Obere Schätzung",
  // Chart field names
  stats_period: "Zeitraum",
  stats_count: "Anzahl",
  stats_name: "Name",

  // KPI tooltips
  stats_cancellation_rate_tooltip:
    "Wie oft Buchungen storniert werden.<br><br><b>Formel:</b> storniert ÷ (genehmigt + erledigt + storniert)<br><b>Beispiel:</b> 10 Buchungen, 2 storniert = <b>20%</b>",
  stats_customer_ltv_tooltip:
    "Wie viel ein Kunde insgesamt bei dir ausgegeben hat — über die gesamte Kundengeschichte, nicht nur im gewählten Zeitraum.",
  stats_utilization_tooltip:
    "Wie voll dein Kalender ist.<br><br><b>100%</b> — jeder verfügbare Slot war gebucht<br><b>50%</b> — die Hälfte deiner Arbeitszeit hatte keine Buchungen",
  stats_booking_payment_rate_tooltip:
    "Anteil der bezahlten Buchungen an allen im gewählten Zeitraum geplanten Buchungen.",
  stats_renewal_rate_tooltip:
    "Wie viele Abonnenten ihren Plan nach der ersten Zahlung verlängert haben — ein Zeichen für Kundenzufriedenheit.",
  stats_average_lead_time_tooltip:
    "Wie viele Tage im Voraus Kunden durchschnittlich buchen. Hohe Zahlen bedeuten vorausschauende Planung; niedrige bedeuten Last-Minute-Buchungen.",
  stats_median_lead_time_tooltip:
    "Typische Anzahl der Tage, die Kunden im Voraus buchen. Anders als der Durchschnitt wird diese Zahl durch wenige sehr frühe oder späte Buchungen kaum beeinflusst.",
  stats_unused_booking_slots_tooltip:
    "Die Gesamtzahl der Buchungen, die Abonnenten hätten machen können (basierend auf ihren Planlimits), aber nicht gemacht haben.<br><br><b>Beispiel:</b> 3 Abonnenten haben je einen Plan mit 10 Buchungen/Monat. Einer nutzte 7, einer 3, einer 0. Das ergibt 3 + 7 + 10 = <b>20 ungenutzte Buchungen</b>.<br><br>Eine hohe Zahl könnte bedeuten, dass deine Limits zu großzügig sind oder Abonnenten eine Erinnerung zum Buchen brauchen.",
  stats_active_subscriptions_tooltip:
    "Neue Abonnements, die im gewählten Zeitraum gestartet wurden. Das ist <b>nicht</b> die Gesamtzahl aller aktiven Abonnenten.",
  stats_avg_utilization_tooltip:
    'Manche Abo-Pläne enthalten eine bestimmte Anzahl an Buchungen (z.B. "10 Buchungen pro Monat"). Das zeigt, welchen Prozentsatz dieser Buchungen deine Abonnenten tatsächlich genutzt haben.<br><br><b>Beispiel:</b> Ein Kunde kauft einen Plan mit 10 Buchungen/Monat, bucht aber nur 3 Mal → das sind 30% Nutzung.<br><br>Ein niedriger Prozentsatz bedeutet, dass Abonnenten nicht voll nutzen, wofür sie bezahlt haben. Zählt nur genehmigte und erledigte Buchungen.',
  // Dashboard KPIs
  stats_new_customers_tooltip:
    "Neue Kunden, die sich im gewählten Zeitraum registriert haben. Basierend auf dem Erstellungsdatum des Kontos.",
  // Revenue section KPIs
  stats_total_revenue_tooltip:
    "Gesamteinnahmen im gewählten Zeitraum aus:<br>• Buchungen<br>• Abonnements<br>• Produktverkäufen<br><br>Nur <b>abgeschlossene Zahlungen</b> werden gezählt, basierend auf dem Zahlungsdatum.",
  stats_from_bookings_tooltip:
    "Einnahmen aus Buchungszahlungen im gewählten Zeitraum. Nur <b>abgeschlossene Zahlungen</b> werden gezählt.",
  stats_from_products_tooltip:
    "Einnahmen aus Einmalkäufen von Produkten im gewählten Zeitraum.",
  stats_from_subscriptions_tooltip:
    "Einnahmen aus Abonnementzahlungen im gewählten Zeitraum.",
  // Booking status KPIs
  stats_total_bookings_tooltip:
    "Gesamtzahl der Buchungen mit Status <b>genehmigt</b> und <b>erledigt</b> im gewählten Zeitraum. <b>Stornierte</b> und Buchungen mit <b>ausstehender Zahlung</b> werden nicht gezählt.",
  stats_approved_tooltip:
    "Buchungen mit Status <b>genehmigt</b> (bestätigt), die noch nicht stattgefunden haben.",
  stats_done_tooltip:
    "Buchungen, die im gewählten Zeitraum erfolgreich abgeschlossen wurden (<b>erledigt</b>).",
  stats_cancelled_tooltip:
    "Buchungen, die im gewählten Zeitraum <b>storniert</b> wurden — von Kunden oder dir.",
  // Team summary KPIs
  stats_active_employees_tooltip:
    "Teammitglieder mit mindestens einer genehmigten oder erledigten Buchung im gewählten Zeitraum.",
  stats_team_revenue_tooltip:
    "Gesamteinnahmen aus Buchungen aller Teammitglieder im gewählten Zeitraum. Nur abgeschlossene Zahlungen werden gezählt.",
  stats_schedule_fill_rate_tooltip:
    'Wie viel der verfügbaren Zeit deines Teams mit Buchungen belegt ist.<br><br><b>So rechnen wir:</b><br>1. Für jedes Teammitglied prüfen wir jeden Tag im Zeitraum<br>2. Für jeden Tag prüfen wir den Zeitplan — spezielle Datumsüberschreibungen (freie Tage, Sonderstunden) haben Vorrang vor dem Wochenplan<br>3. Wir addieren alle gebuchten Stunden (genehmigte und erledigte Buchungen)<br>4. Auslastung = gebuchte Stunden ÷ verfügbare Stunden<br>5. Wir bilden den Durchschnitt über alle Teammitglieder<br><br><b>Beispiel:</b> Anna hat 40h verfügbar, 20h gebucht → 50%. Mark hat 40h verfügbar, 30h gebucht → 75%. Durchschnitt = <b>62,5%</b><br><br>Teammitglieder ohne Zeitplan werden übersprungen. "--" bedeutet, dass niemand einen Zeitplan hat.',
  stats_total_booked_hours_tooltip:
    "Gesamtstunden, die im gewählten Zeitraum für Buchungen im gesamten Team aufgewendet wurden.",
  // Employee KPIs
  stats_customers_served_tooltip:
    "Anzahl verschiedener Kunden, mit denen dieses Teammitglied im gewählten Zeitraum gearbeitet hat.",
  stats_available_hours_tooltip:
    'Wie viele Stunden dieses Teammitglied im gewählten Zeitraum arbeiten konnte, basierend auf seinem Zeitplan.<br><br><b>So rechnen wir:</b> Wir prüfen jeden Tag im Zeitraum. Hat ein Tag eine spezielle Überschreibung (z.B. ein freier Tag), verwenden wir diese. Sonst gilt der reguläre Wochenplan.<br><br><b>Beispiel:</b> Mo–Fr 9:00–17:00. Zeitraum = Mo bis So → 5 Arbeitstage × 8h = <b>40h</b>. Wenn der Mittwoch als frei markiert ist, werden es 4 × 8h = <b>32h</b>.<br><br>"--" bedeutet, dass kein Zeitplan festgelegt ist.',
  stats_booked_hours_tooltip:
    "Arbeitsstunden, die tatsächlich mit Buchungen gefüllt waren, im gewählten Zeitraum.",
  // Customer KPIs
  stats_total_tooltip:
    "Gesamtzahl der bei dir registrierten Kunden — über die gesamte Zeit, nicht nur im gewählten Zeitraum.",
  stats_new_tooltip:
    "Kunden, die im gewählten Zeitraum zum ersten Mal gebucht haben — sie hatten vorher keine Buchungen.",
  stats_active_tooltip:
    "Kunden, die im gewählten Zeitraum mindestens eine Buchung mit Status <b>genehmigt</b> oder <b>erledigt</b> hatten.",
  stats_returning_tooltip:
    "Kunden, die bereits vor dem gewählten Zeitraum gebucht haben und im gewählten Zeitraum wiedergekehrt sind.",
  stats_ltv_tooltip:
    "Durchschnittlicher Gesamtbetrag, den ein Kunde seit seiner Registrierung ausgegeben hat — über die gesamte Zeit, nicht nur im gewählten Zeitraum.",
  stats_preferred_delivery_type_tooltip:
    "Das häufigste Buchungsformat, das deine Kunden wählen – zum Beispiel persönlich, telefonisch oder online.",
  stats_preferred_payment_method_tooltip:
    "Die Zahlungsmethode, die deine Kunden am häufigsten für Buchungen verwenden.",
  stats_total_customers_tooltip:
    "Gesamtzahl registrierter Kunden — über die gesamte Zeit, nicht nur im gewählten Zeitraum.",
  stats_active_customers_tooltip:
    "Kunden, die im gewählten Zeitraum mindestens eine Buchung hatten.",
  stats_returning_customers_tooltip:
    "Kunden, die vor dem gewählten Zeitraum gebucht haben und im Zeitraum wiedergekommen sind. Bei <b>Gesamtzeitraum</b> ist das Ergebnis 0.",
  stats_retention_rate_tooltip:
    "Wie viel Prozent der aktiven Kunden schon vorher bei dir gebucht haben.<br><br><b>Formel:</b> wiederkehrend ÷ aktiv × 100<br><b>Beispiel:</b> 10 aktive, 6 wiederkehrende = <b>60%</b>",
  stats_avg_days_between_visits_tooltip:
    "Wie viele Tage durchschnittlich zwischen den Buchungen von Kunden vergehen, die mehr als einmal kommen.",
  // Product KPIs
  stats_total_sold_tooltip:
    "Anzahl der im gewählten Zeitraum verkauften Produkte.",
  stats_product_revenue_tooltip:
    "Gesamteinnahmen aus Produktverkäufen im gewählten Zeitraum.",
  // Subscription KPIs
  stats_subscription_revenue_tooltip:
    "Gesamteinnahmen aus Abonnementzahlungen im gewählten Zeitraum.",
  stats_active_users_tooltip:
    "Abonnenten, die im gewählten Zeitraum mindestens eine Buchung mit ihrem Abonnement gemacht haben.",
  // Payment KPIs
  stats_total_value_tooltip:
    "Summe aller <b>abgeschlossenen</b> Zahlungstransaktionen (Buchungen, Produkte und Abonnements) im gewählten Zeitraum.",
  // Pattern KPIs
  stats_busiest_day_tooltip:
    "Der Wochentag mit den meisten Buchungen im gewählten Zeitraum.",
  stats_busiest_hour_tooltip:
    "Die Tageszeit mit den meisten Buchungen im gewählten Zeitraum.",
  stats_peak_times_tooltip:
    "Tag und Stunde mit den meisten Buchungen mit Status <b>genehmigt</b> und <b>erledigt</b> im gewählten Zeitraum.",
  stats_bookings_by_hour_tooltip:
    "Wie sich die Buchungen auf die Tagesstunden im gewählten Zeitraum verteilen.",
  stats_bookings_by_service_tooltip:
    "Welche Dienstleistungen im gewählten Zeitraum am meisten gebucht wurden.",
  stats_bookings_by_employee_tooltip:
    "Welche Teammitglieder im gewählten Zeitraum die meisten Buchungen bearbeitet haben.",
  stats_booking_lead_time_tooltip:
    "Wie weit im Voraus Kunden buchen — die Anzahl der Tage zwischen Buchungserstellung und Buchungsdatum.",
  stats_bookings_by_location_tooltip:
    "Wie sich die Buchungen auf deine Standorte im gewählten Zeitraum verteilen.",
  // Forecast KPIs
  stats_low_estimate_tooltip:
    "Das untere Ende der Prognose — deine Ergebnisse könnten auf diesem Niveau liegen, wenn der nächste Zeitraum ruhiger ist als üblich.",
  stats_high_estimate_tooltip:
    "Das obere Ende der Prognose — das optimistische Szenario für den nächsten Zeitraum.",
  // Widget-specific tooltips (shared with dashboard widgets)
  stats_booking_status_tooltip:
    "Aufschlüsselung deiner Buchungen nach Status — <b>genehmigt</b>, <b>erledigt</b> und <b>storniert</b> — im gewählten Zeitraum.",
  stats_avg_booking_value_tooltip:
    "Der durchschnittliche Betrag pro Buchung im gewählten Zeitraum.<br><br><b>Formel:</b> Buchungsumsatz ÷ Anzahl bezahlter Buchungen",
  stats_mrr_tooltip:
    "Gesamtumsatz aus Abonnementzahlungen im gewählten Zeitraum. Zeigt die Summe aller bezahlten Abonnementtransaktionen, nicht eine normalisierte Monatsrate.",
  stats_top_clients_tooltip:
    "Deine umsatzstärksten Kunden im gewählten Zeitraum, nach Gesamtumsatz sortiert.",
  stats_top_service_tooltip:
    "Die Dienstleistung mit den meisten Buchungen im gewählten Zeitraum.",
  stats_revenue_trend_tooltip:
    "Wie sich dein Umsatz im gewählten Zeitraum verändert hat. Beinhaltet Buchungen, Abonnements und Produktverkäufe.<br><br><b>Prognose:</b> gestrichelte Linie für kommende Zeiträume — Buchungsumsatz bereits eingegangen oder ausstehend, plus geschätzter monatlicher Umsatz aus aktiven Abonnements.",
  stats_bookings_timeline_tooltip:
    "Wie sich die Anzahl der Buchungen im gewählten Zeitraum verändert hat. Beinhaltet Buchungen mit Status <b>genehmigt</b> und <b>erledigt</b>.<br><br><b>Prognose:</b> gestrichelte Linie für kommende Zeiträume — Buchungen, die bereits geplant sind (<b>genehmigt</b> oder <b>ausstehende Zahlung</b>).",
  stats_peak_hours_heatmap_tooltip:
    "Heatmap, die zeigt, wann die meisten Buchungen stattfinden — nach Wochentag und Uhrzeit. Dunklere Felder = mehr Buchungen.",
  stats_booking_revenue_tooltip:
    "Umsatz nur aus Buchungszahlungen im gewählten Zeitraum — ohne Produktverkäufe und Abonnements.",
  stats_total_transactions_tooltip:
    "Gesamtzahl der Zahlungstransaktionen im gewählten Zeitraum, aus allen Quellen.",
  stats_payment_timeline_tooltip:
    "Wie sich der Gesamtwert der Zahlungen im gewählten Zeitraum verändert hat.",
  stats_revenue_timeline_tooltip:
    "Einnahmen nach Quelle aufgeschlüsselt — Buchungen, Abonnements und Produkte. Nur abgeschlossene Zahlungen, basierend auf dem Zahlungsdatum. Klicke auf Legendeneinträge, um Linien ein- oder auszublenden.<br><br><b>Prognose</b>: gestrichelte Linien zeigen prognostizierte Einnahmen — aus bereits bezahlten oder ausstehenden Buchungen sowie geschätztem Umsatz aus aktiven Abonnements.",
  stats_revenue_top_services_table_tooltip:
    "Dienstleistungen nach Umsatz im gewählten Zeitraum sortiert.",
  stats_revenue_top_products_table_tooltip:
    "Produkte nach Umsatz im gewählten Zeitraum sortiert.",
  stats_payment_providers_chart_tooltip:
    "Anzahl <b>abgeschlossener</b> Transaktionen nach Zahlungsmethode (z.\u00A0B. Stripe, Bar, Karte) im gewählten Zeitraum.",
  stats_payment_methods_count_chart_tooltip:
    "Wie viele Transaktionen über jede Zahlungsmethode im gewählten Zeitraum abgewickelt wurden.",
  stats_payment_methods_value_chart_tooltip:
    "Gesamtumsatz über jede Zahlungsmethode im gewählten Zeitraum.",
  stats_booking_status_chart_tooltip:
    "Buchungen nach Status — <b>genehmigt</b>, <b>erledigt</b>, <b>storniert</b> und <b>ausstehende Zahlung</b> — im gewählten Zeitraum.",
  stats_cancellation_reasons_chart_tooltip:
    "Häufigste Gründe, warum Kunden ihre Buchungen im gewählten Zeitraum storniert haben.",
  stats_busiest_day_chart_tooltip:
    "Welche Wochentage die meisten Buchungen im gewählten Zeitraum haben.",
  stats_delivery_type_chart_tooltip:
    "Wie sich die Buchungen auf Durchführungsarten verteilen — vor Ort, online, telefonisch usw. — im gewählten Zeitraum.",
  stats_customer_segments_chart_tooltip:
    "Wie engagiert deine aktiven Kunden im gewählten Zeitraum sind:<br>• <b>Erstbesucher</b> — erste Buchung überhaupt, keine vorherige Geschichte<br>• <b>Wiedergekommen</b> — hatten vorher Buchungen, einmal in diesem Zeitraum<br>• <b>Stammkunden</b> — hatten vorher Buchungen und kamen 2+ Mal in diesem Zeitraum",
  stats_top_customers_table_tooltip:
    "Deine umsatzstärksten Kunden im gewählten Zeitraum — vollständige Tabelle mit Exportmöglichkeit.",
  stats_employee_table_tooltip:
    "Leistungsübersicht für jedes Teammitglied — Buchungen, Stunden und Auslastung im gewählten Zeitraum.",
  stats_service_table_tooltip:
    "Leistungsübersicht für jede Dienstleistung — Buchungen und Umsatz im gewählten Zeitraum.",
  stats_services_by_category_tooltip:
    "Anzahl genehmigter und erledigter Buchungen pro Dienstleistungskategorie im gewählten Zeitraum.",
  stats_subscription_timeline_tooltip:
    "Wie viele neue Abonnements pro Zeitraum abgeschlossen wurden. Gezählt werden Startdaten — Verlängerungen sind nicht enthalten.",
  stats_top_subscriptions_table_tooltip:
    "Abonnement-Pläne nach Anzahl aktiver Abonnenten im gewählten Zeitraum sortiert.",
  stats_product_timeline_tooltip:
    "Wie sich der Produktumsatz im gewählten Zeitraum verändert hat.",
  stats_top_products_table_tooltip:
    "Produkte nach Verkaufsvolumen und Umsatz im gewählten Zeitraum sortiert.",
  stats_not_assigned: "Nicht zugewiesen",
  stats_low: "Niedrig",
  stats_medium: "Mittel",
  stats_high: "Hoch",
  stats_insufficient: "Unzureichende Daten",
  stats_type_name: "Lieferart",
  stats_new_subscriptions: "Neue Abonnements",
  stats_new: "Neu",
  stats_returning: "Wiederkehrend",
  stats_first_time: "Erstbesucher",
  stats_first_time_tooltip:
    "Kunden ohne Buchungen vor dem gewählten Zeitraum — das ist ihr erster Besuch.",
  stats_came_back: "Wiedergekommen",
  stats_came_back_tooltip:
    "Kunden, die vorher Buchungen hatten und einmal in diesem Zeitraum gebucht haben.",
  stats_loyal: "Stammkunden",
  stats_loyal_tooltip:
    "Kunden, die vorher Buchungen hatten und 2+ Mal in diesem Zeitraum gebucht haben.",
  stats_staff: "Mitarbeiter",
  stats_payment_timeout: "Zahlungszeitüberschreitung",
  stats_calendar_sync: "Kalender-Synchronisation",
  stats_in_person: "Adresse",
  stats_phone: "Telefon",
  stats_other: "Andere",
  stats_stripe: "Stripe",
  stats_cash: "Bar",
  stats_card: "Karte",
  stats_transfer: "Überweisung",
  stats_google_meet: "Google Meet",
  stats_zoom: "Zoom",
  stats_microsoft_teams: "Microsoft Teams",
  stats_skype: "Skype",
  stats_whatsapp: "WhatsApp",
  stats_client: "Kunde",
  stats_no_payment: "Zahlungszeitüberschreitung",
  stats_external: "Kalender-Synchronisation",
  bulk_operation_progress: "Verarbeitung: @{done} von @{total}",
  bulk_operation_counting: "Datensätze werden gezählt...",
  bulk_action_delete_bookings: "Buchungen löschen",
  bulk_action_delete_users: "Benutzer löschen",
  bulk_action_update_users: "Benutzer aktualisieren",
  bulk_action_export_users: "Benutzer exportieren",
  bulk_action_add_to_group: "Zu Gruppen hinzufügen",
  bulk_action_remove_from_group: "Aus Gruppen entfernen",
  bulk_action_send_notification: "Benachrichtigungen senden",
  bulk_action_update_bookings: "Buchungen aktualisieren",
  bulk_action_export_events: "Ereignisse exportieren",
  bulk_action_update_employees: "Mitarbeiter aktualisieren",
  bulk_action_delete_employees: "Mitarbeiter löschen",
  bulk_action_export_employees: "Mitarbeiter exportieren",
  bulk_notification_sending: "Benachrichtigungen werden gesendet...",
  bulk_export_generating: "Datei wird generiert...",
  bulk_export_sent_to_email: "Datei wurde an Ihre E-Mail gesendet",
  bulk_export_sent_to_email_with_errors:
    "Datei wurde an Ihre E-Mail gesendet. Verarbeitet: @{processed}, Fehler: @{failed}.",
  download_csv: "CSV herunterladen",
  selection_all_on_page:
    "Alle @{amount} Einträge auf dieser Seite sind ausgewählt.",
  selection_select_all_records:
    "Alle @{total} Einträge auf allen Seiten auswählen",
  selection_all_records_selected:
    "Alle @{total} Einträge auf allen Seiten sind ausgewählt.",

  // Dashboard widgets
  your_overview: "Deine Übersicht",
  add_widget: "Widget hinzufügen",
  widget_group_revenue: "Umsatz",
  widget_group_bookings: "Buchungen",
  widget_group_clients: "Kunden",
  widget_group_team: "Mein Team",
  widget_group_subscriptions: "Abonnements",
  widget_group_products: "Produkte",
  widget_revenue_kpi: "Umsatz",
  widget_bookings_kpi: "Buchungen",
  widget_new_clients_kpi: "Neue Kunden",
  widget_revenue_trend: "Umsatztrend",
  widget_cancellation_rate: "Stornoquote",
  widget_top_clients: "Top-Kunden",
  widget_peak_hours_heatmap: "Stoßzeiten",
  widget_avg_booking_value: "Durchschn. Buchungswert",
  widget_payment_method: "Bevorzugte Zahlungsmethode",
  widget_bookings_timeline: "Buchungen im Zeitverlauf",
  widget_booking_status: "Buchungsstatus",
  widget_busiest_day: "Aktivster Tag",
  widget_busiest_hour: "Aktivste Stunde",
  widget_avg_lead_time: "Durchschn. Vorlaufzeit",
  widget_active_clients: "Aktive Kunden",
  widget_retention_rate: "Bindungsrate",
  widget_employee_utilization: "Mitarbeiterauslastung",
  widget_top_service: "Top-Dienstleistung",
  widget_active_subscriptions: "Aktive Abonnements",
  widget_mrr: "Aboeinnahmen",
  widget_product_revenue: "Produktumsatz",
  widget_booking_revenue: "Buchungsumsatz",
  widget_total_transactions: "Alle Transaktionen",
  widget_payment_conversion: "Buchungszahlungsrate",
  widget_payment_timeline: "Zahlungen im Zeitverlauf",
  widget_revenue_timeline: "Umsatz im Zeitverlauf",
  widget_revenue_top_services_table: "Top Dienstleistungen nach Umsatz",
  widget_revenue_top_products_table: "Top Produkte nach Umsatz",
  widget_payment_providers_chart: "Zahlungsmethoden",
  widget_booking_status_chart: "Buchungsstatus-Verteilung",
  widget_cancellation_reasons_chart: "Stornierungsgründe",
  widget_busiest_day_chart: "Buchungen nach Wochentag",
  widget_delivery_type_chart: "Verteilung nach Durchführungsart",
  widget_customer_segments_chart: "Kundensegmente",
  widget_top_customers_table: "Top Kunden (vollständige Tabelle)",
  widget_employee_table: "Mitarbeiterleistung",
  widget_service_table: "Dienstleistungsübersicht",
  widget_subscription_timeline: "Neue Abonnements im Zeitverlauf",
  widget_top_subscriptions_table: "Top Abonnement-Pläne",
  widget_product_timeline: "Produkt-Umsatz im Zeitverlauf",
  widget_top_products_table: "Top Produkte",
  widget_bookings_by_service_table: "Buchungen nach Dienstleistung",
  widget_bookings_by_employee_table: "Top Teammitglieder",
  widget_bookings_by_hour_chart: "Buchungen nach Uhrzeit",
  widget_locations_table: "Buchungen nach Standort",
  widget_total_clients: "Alle Kunden",
  widget_customer_ltv: "Kundenwert (LTV)",
  widget_returning_clients: "Wiederkehrende Kunden",
  widget_avg_days_between_visits: "Durchschn. Tage zwischen Besuchen",
  widget_first_time_clients: "Erstkunden",
  widget_repeat_clients: "Wiederkehrende Kunden",
  widget_loyal_clients: "Treue Kunden",
  widget_services_by_category_chart: "Buchungen nach Kategorie",
  widget_renewal_rate: "Verlängerungsrate",
  widget_subscription_utilization: "Abo-Auslastung",
  widget_unused_booking_slots: "Ungenutzte Buchungsplätze",
  widget_total_products_sold: "Verkaufte Produkte",
  restore_defaults: "Standard wiederherstellen",
  restore_defaults_warning:
    "Dadurch wird dein Dashboard auf die Standard-Widgets zurückgesetzt. Dein aktuelles Layout geht verloren.",
  drag_to_reorder: "Zum Neuordnen ziehen",
  tooltip_add_widget: "Neues Widget zum Dashboard hinzufügen",
  tooltip_edit_layout: "Widgets neu anordnen oder entfernen",
  tooltip_restore_defaults: "Standard-Widget-Layout wiederherstellen",
  tooltip_save_layout: "Aktuelles Widget-Layout speichern",
  tooltip_remove_widget: "Dieses Widget entfernen",
  add_more_widgets: "Weitere Widgets hinzufügen",
  all_time: "Gesamtzeitraum",
  remove_from_group: "Aus Gruppe entfernen",
  change_status_to_approved: "Als genehmigt setzen",
  change_status_to_payment: "Als ausstehende Zahlung setzen",
  change_status_to_cancelled: "Als storniert setzen",
  change_status_to_done: "Als erledigt setzen",
  bulk_operation_already_active:
    "Du hast bereits einen aktiven Massenvorgang. Bitte warte, bis er abgeschlossen ist.",
};
